import { render, staticRenderFns } from "./AddApi.vue?vue&type=template&id=68cffd98&scoped=true"
import script from "./AddApi.vue?vue&type=script&lang=js"
export * from "./AddApi.vue?vue&type=script&lang=js"
import style0 from "./AddApi.vue?vue&type=style&index=0&id=68cffd98&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cffd98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cffd98')) {
      api.createRecord('68cffd98', component.options)
    } else {
      api.reload('68cffd98', component.options)
    }
    module.hot.accept("./AddApi.vue?vue&type=template&id=68cffd98&scoped=true", function () {
      api.rerender('68cffd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/AddApi.vue"
export default component.exports